<template>
  <div class="contents_wrapper">
    <div class="contents">
      <TableBox :table-contents="balanceData" :is-with-header="true"/>

      <button @click="payout()" v-if="isAvailablePayout" class="active-rectangle_button">出金する</button>
      <div v-else class="inactive-rectangle_button">出金は同じ月に1度だけ可能です</div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import dayjs from "dayjs";
  import caller from "@/assets/js/functions/firebase/cloud_functions/caller";
  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import toast from "@/assets/js/functions/_core/toast";

  import TableBox from "@/components/molecules/box/TableBox";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";

  export default {
    name: "PayoutBalances",

    components: {TableBox},

    mixins: [caller, collection, toast],

    data() {
      return {
        available: null,
        pending: null,
        operatorStripe: {}
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid'}),


      // 今月に支払いが行われたかどうか
      hasPaidOutThisMonth() {
        const thisYear = dayjs().year();
        const paidOutYear = dayjs.unix(this.operatorStripe.paidOutAt.seconds).year();

        const thisMonth = dayjs().month() + 1;
        const paidOutMonth = dayjs.unix(this.operatorStripe.paidOutAt.seconds).month() + 1;

        return paidOutYear === thisYear && paidOutMonth === thisMonth;
      },
      isAvailablePayout() {
        // 支払いが行われたことがないなら利用可能
        if (!this.operatorStripe || !this.operatorStripe.paidOutAt) return true;

        // 支払い月が今月なら利用不可
        if (this.hasPaidOutThisMonth) {
          return false;
        } else {
          // 残高が0ではない場合True
          return (this.available && this.available > 0);
        }
      },
      balanceData() {
        return {
          header: {
            dt: '出金可能残高',
            dd: 'まもなくご利用可能',
          },
          officeName: {
            dt: `￥${this.available}`,
            dd: `￥${this.pending}`,
          }
        }
      },
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      await this.getDoc(
        COLLECTION_NAMES.OPERATOR_STRIPES,
        this.uid,
        {}).then(async operatorStripe => {
        this.operatorStripe = operatorStripe;
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });
    },

    async mounted() {
      this.getBalance()
    },

    methods: {
      async getBalance() {
        const params = {
          userId: this.uid,
        };

        await this.callFunction(
          'getBalanceByStripe',
          params
        ).then((result) => {
          this.available = result.balance.available;
          this.pending = result.balance.pending;
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        });
      },

      async payout() {
        const params = {
          userId: this.uid,
          amount: this.available,
        };

        await this.callFunction(
          'payoutByStripe',
          params
        ).then(() => {
          this.getBalance();
          this.showSuccessMessage('出金しました。');
          this.showSuccessMessage('口座に振り込まれるまで、しばらくお待ちください。');
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        });
      }
    },
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background-color: $operator_primary;

    > .contents {
      @include index-contents();
    }
  }
</style>